
class CompsError extends Error {
    constructor(message) {
        super(message)
        this.message = message || 'Unable to process your request, please reach out to Technical team.'
      }
}
export {
    CompsError
}
